import { parseStartingSpeedKmh } from '../../game/testPlay.ts';
import { setPanel } from '../panels.ts';

export function openStartingSpeedDialog(options: {
  onAccept: (kmh: number) => void;
  onCancel: () => void;
}): void {
  setPanel('editorDialog', {
    title: 'Starting speed',
    message: 'Speed when the boat is planted.',
    confirmLabel: 'Set',
    cancelLabel: 'Cancel',
    inputDefault: '0',
    inputLabel: 'km/h',
    selectOnFocus: true,
    onConfirm: (value) => {
      const kmh = parseStartingSpeedKmh(value);

      if (kmh === null) {
        return;
      }

      setPanel('editorDialog', null);
      options.onAccept(kmh);
    },
    onCancel: () => {
      setPanel('editorDialog', null);
      options.onCancel();
    },
  });
}

export function closeStartingSpeedDialog(): void {
  setPanel('editorDialog', null);
}
